<main id="main-content" class="main-content" [formGroup]="form">
  @if (errorList.length > 0) {
    <div class="red-warning">
      <mat-icon class="red-warn-icon">warning</mat-icon>
      <div class="red-warn-text">
        <span class="red-title">Incomplete section</span>
        <span class="red-text">
          The following fields are missing details. Please complete them before proceeding to the next section:
          <ul>
            @for (error of errorList; track error) {
              <li>{{error | titlecase}}</li>
            }
          </ul>
        </span>
      </div>
    </div>
  }
  <div class="subtitle"><span class="red-normal">*</span>Indicates required field</div>
  <h2 class="form-header">2. Authorized and Completed Treatments</h2>
  <span class="gray-text" style="margin-bottom: 10px;"><b>Tip:</b> To expand or collapse all treatment cards,
select “Ctrl” on your keyboard and click over a treatment card.</span>

@for (treatmentType of treatmentTypes; track treatmentType; let i = $index) {
  <div class="forest-container">
    <h2 class="treatment-type" [id]="treatmentType.treatment_type_id">{{ treatmentType.treatment_type}}</h2>
    <mat-accordion [multi]="true" #accordion="matAccordion">
      @for(treatment of treatmentList; track treatment; let j = $index) {
        @if (treatment.treatment.treatment_type_id == treatmentType.treatment_type_id) {
          <mat-expansion-panel
            class="treatment-container" expanded="false" hideToggle (opened)="treatment.open = true"
            (closed)="treatment.open = false" (click)="onTreatmentClick($event, accordion)"
            (onkeypress)="onTreatmentKeypress($event, accordion)" onkeypress="">
            <mat-expansion-panel-header>
              <mat-panel-title class="treatment-title">
                @if (treatment.open) {
                  <i class="material-icons green-arrow" role="img">keyboard_arrow_down</i>
                }
                @if (!treatment.open) {
                  <i class="material-icons green-arrow" role="img">chevron_right</i>
                }
                @if(
                  (((treatment.form?.value?.units ?? -1) === -1)
                  && (treatment.form?.value?.date_completed == null)
                  && (treatment.form?.value?.method_id == null)
                  && (treatment.form?.value?.status_statement == '')
                  )){
                  <mat-icon class="icon-status nav-status-0" matTooltip='Not Started'
                  matTooltipClass="tooltipClass">panorama_fish_eye</mat-icon>
                }
                @else if(
                ((treatment.form?.value?.units ?? -1) === -1)
                || (treatment.form?.value?.date_completed == null)
                || (treatment.form?.value?.method_id == null)
                || ((treatment.form?.value?.method_id == 0) && (((treatment.form?.value?.contract_id ?? '') ==
                '') || (treatment.form?.value?.contract_status_id == null)))
                || ((treatment.form?.value?.method_id == 1) && ((treatment.form?.value?.agreement ?? '') == ''))
                || (treatment.form?.value?.status_statement == '')
                ){
                <mat-icon class="icon-status nav-status-1" matTooltip='In Progress'
                matTooltipClass="tooltipClass">contrast</mat-icon>
              }
              @else {
              <mat-icon class="icon-status nav-status-2" matTooltip='Complete'
              matTooltipClass="tooltipClass">check_circle</mat-icon>
            }
            <div class="treatment-title-info">
              <div>{{treatment.forest_name}}</div>
              <span class="thin">
                {{ treatment?.treatment?.treatment_option?.treatment_option }}
                ({{treatment?.treatment?.treatment_option?.unit_of_measure}})
                (Spec.{{treatment?.treatment.treatment_specifications[0].specification_number}})
              </span>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        @if (treatment.form) {
          <div [formGroup]="treatment.form">
            <h3>Authorized</h3>
            <div class="whole-line" style="flex-wrap: wrap;">
              <div class="quarter-div">
                <p class="data-title"># of Units</p>
                <p class="data-info">{{treatment.totalUnits}}
                </p>
              </div>
              <div class="quarter-div">
                <p class="data-title">Total ($)</p>
                <p class="data-info">{{calcTotalAuth(treatment) | currency}}</p>
              </div>
            </div>
            <h3>Completed</h3>
            <div class="whole-line" style="flex-wrap: wrap;">
              <div class="quarter-div field-div">
                <mat-form-field appearance="outline" class="quarter-field" style="margin-left: 0;">
                  <mat-label># of Units</mat-label>
                  <input thousandSeparator="," mask="separator" decimalMarker="." matInput
                    aria-label="Units" formControlName="units" required>
                    <mat-error>
                      # must be at or below {{treatment.totalUnits}}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="quarter-div">
                  <p class="data-title">Total ($)</p>
                  <p class="data-info">{{calcTotalCompleted(treatment) | currency}}</p>
                </div>
                <div class="quarter-div field-div">
                  <mat-form-field appearance="outline" class="short-field">
                    <mat-label class="short-field">Date Completed</mat-label>
                    <input matInput formControlName="date_completed" required [matDatepicker]="picker1"
                      placeholder="MM/dd/yyyy" aria-label="Date Contained">
                      <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                      <mat-error>Required Field</mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="whole-line" style="flex-wrap: wrap;">
                  <div class="quarter-div field-div">
                    <mat-form-field appearance="outline" class="quarter-field" style="margin-left: 0;">
                      <mat-label>Method</mat-label>
                      <mat-select formControlName="method_id" required>
                        @for (method of methods; track method) {
                          <mat-option [value]="method.method_id">{{method.method}}</mat-option>
                        }
                      </mat-select>
                      <mat-error>Required Field</mat-error>
                    </mat-form-field>
                  </div>
                  @if (treatment.form.value.method_id === 0) {
                    <div class="quarter-div field-div">
                      <mat-form-field appearance="outline" class="quarter-field" style="margin-left: 0;">
                        <mat-label>Contract ID</mat-label>
                        <input matInput placeholder="0000000000" mask="0000000000" aria-label="Units"
                          formControlName="contract_id" required>
                        </mat-form-field>
                      </div>
                    }
                    @if (treatment.form.value.method_id === 0) {
                      <div class="quarter-div field-div">
                        <mat-form-field appearance="outline" class="quarter-field" style="margin-left: 0;">
                          <mat-label>Contract Status</mat-label>
                          <mat-select formControlName="contract_status_id" required>
                            @for (contract_status of contract_status_list; track contract_status) {
                              <mat-option
                              [value]="contract_status.contract_status_id">{{contract_status.contract_status}}</mat-option>
                            }
                          </mat-select>
                          <mat-error>Required Field</mat-error>
                        </mat-form-field>
                      </div>
                    }
                    @if (treatment.form.value.method_id === 1) {
                      <div class="quarter-div field-div">
                        <mat-form-field appearance="outline" class="quarter-field" style="margin-left: 0;">
                          <mat-label>Agreement ID</mat-label>
                          <input matInput placeholder="0000000000" mask="0000000000" aria-label="Units"
                            formControlName="agreement" required>
                          </mat-form-field>
                        </div>
                      }
                    </div>
                    <div class="text-div">
                      <b><span class="red-normal">*</span>Provide a status and major changes or plans for project
                    completion </b>
                    <br>
                      <span class="gray-text">Describe any major changes from request to implementation (i.e. what was
                      changed and why) or any plans for project completion for this treatment.</span>
                    </div>
                    <span class="gray-text tip-text"><b>Tip:</b> Use Ctrl+Shift+V to paste as plain text.</span>
                    <div class="NgxEditor__Wrapper">
                      <ngx-editor-menu [editor]="treatment.editor" [toolbar]="toolbar"></ngx-editor-menu>
                      <ngx-editor formControlName="status_statement" [editor]="treatment.editor" required
                        placeholder="Enter Description"
                      (ngModelChange)="onChangeEditor($event, treatment)"></ngx-editor>
                    </div>
                  </div>
                }
              </mat-expansion-panel>
            }
          }
        </mat-accordion>
      </div>
    }
    <div class="forest-container">
      <h2 class="forest-title" id="8">Total</h2>
      <mat-accordion [multi]="true" #accordion="matAccordion">
        <mat-expansion-panel class="treatment-container" expanded="false" hideToggle (opened)="open = true"
          (closed)="open = false" (click)="onTreatmentClick($event, accordion)"
          (onkeypress)="onTreatmentKeypress($event, accordion)" onkeypress="">
          <mat-expansion-panel-header>
            <mat-panel-title class="treatment-title">
              @if (open) {
                <i class="material-icons green-arrow" role="img">keyboard_arrow_down</i>
              }
              @if (!open) {
                <i class="material-icons green-arrow" role="img">chevron_right</i>
              }
              <div class="treatment-title-info">
                <div>Total</div>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="whole-line" style="flex-wrap: wrap;">
            <div class="total-container">
              <div class="total-header">Authorized</div>
              <div class="total-subcontainer">
                <div class="sub-header"># of Units</div>
                {{totalUnits | number: '1.0-0'}}
              </div>
              <div class="total-subcontainer">
                <div class="sub-header">Total ($)</div>
                {{totalFunding | currency}}
              </div>
            </div>
            <div class="total-container">
              <div class="total-header">Completed</div>
              <div class="total-subcontainer">
                <div class="sub-header"># of Units</div>
                {{totalCompletedUnits() | number: '1.0-0'}}
              </div>
              <div class="total-subcontainer">
                <div class="sub-header">Total ($)</div>
                {{totalCompletedFunding() | currency}}
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </main>